<template>
  <div id="login">
    <Modal
      title="验证手机号"
      :tapToDismiss="false"
      :onDismiss="state.dismiss"
      :showComplete="false"
      :showClose="showClose"
      v-on:dismiss="$emit('dismiss')"
      v-on:complete="complete"
    >
      <LoginComponent :isComponent="true" v-on:complete="complete" />
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/popup/Modal"
import LoginComponent from "@/components/login/Main"

export default {
  name: "Login",
  props: {
    showClose: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Modal,
    LoginComponent,
  },
  data() {
    return {
      state: {
        dismiss: false,
      },
    }
  },
  methods: {
    async complete() {
      this.state.dismiss = true
      return this.$emit("complete")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./modal.scss";

#login {
}
</style>
